<!-- Shared image block -->
<ng-template #cardImage>
  <div class="worksheet-card_image">
    <img
      width="1600"
      height="900"
      [src]="worksheetItem.Image | contentImage: '6' : 'marketplace'"
      [alt]="worksheetItem.Title"
      [useDefault]="true"
      [loyaltyType]="'marketplace'"
      loading="lazy"
      draggable="false"
    />
  </div>
</ng-template>

<!-- Shared footer -->
<ng-template #cardFooter let-action="action">
  <div class="worksheet-card_footer">
    <p class="worksheet-card_description" [id]="'desc-' + worksheetItem.Id">
      {{ worksheetItem.Description }}
    </p>
    <ng-container *ngTemplateOutlet="action" />
  </div>
</ng-template>

<ng-template #downloadAction>
  <button
    type="button"
    class="worksheet-card_btn bg-button"
    [attr.aria-label]="('worksheet.download' | translate) + ' ' + worksheetItem.Title"
    [attr.aria-describedby]="'desc-' + worksheetItem.Id"
    [disabled]="isDownloading"
    [attr.aria-busy]="isDownloading"
    (click)="getDownload(worksheetId, worksheetItem.Id)"
  >
    {{ 'worksheet.download' | translate | uppercase }}
  </button>
</ng-template>

<ng-template #linkAction>
  <a
    [href]="worksheetItem.LinkUrl"
    target="_blank"
    rel="noopener noreferrer"
    class="worksheet-card_btn"
    [attr.aria-label]="('worksheet.download' | translate) + ' ' + worksheetItem.Title"
    [attr.aria-describedby]="'desc-' + worksheetItem.Id"
  >
    {{ 'worksheet.link' | translate | uppercase }}
    <span class="visually-hidden">({{ 'common.opens_new_tab' | translate }})</span>
  </a>
</ng-template>

<article
  *ngIf="worksheetItem.WorksheetType === worksheetType.Download"
  class="worksheet-card mt-3"
  [attr.aria-label]="worksheetItem.Title"
>
  <ng-container *ngTemplateOutlet="cardImage" />
  <ng-container *ngTemplateOutlet="cardFooter; context: { action: downloadAction }" />
</article>

<ng-container *ngIf="worksheetItem.WorksheetType === worksheetType.Gallery">
  <button
    type="button"
    class="worksheet-card mt-3 worksheet-card-gallery"
    [attr.aria-label]="('worksheet.view' | translate) + ' ' + worksheetItem.Title"
    aria-haspopup="dialog"
    (click)="openGalleryImage(galleryImage)"
  >
    <img
      width="600"
      height="600"
      [src]="worksheetItem.Image | contentImage: '6' : 'marketplace'"
      [alt]="worksheetItem.Title"
      [useDefault]="true"
      [loyaltyType]="'marketplace'"
      loading="lazy"
      draggable="false"
    />
    @if (worksheetItem.Description) {
      <div class="worksheet-card_overlay-body" aria-hidden="true">
        <p class="worksheet-card_overlay-description fw-bold">{{ worksheetItem.Description }}</p>
      </div>
    }
  </button>

  <ng-template #galleryImage let-modal>
    <div class="gallery-modal" role="dialog" aria-modal="true" [attr.aria-label]="worksheetItem.Title">
      <button type="button" class="gallery-modal_close" [attr.aria-label]="'common.close' | translate" (click)="modal.dismiss()">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>

      <div class="gallery-modal_stage">
        <img
          *ngIf="worksheetItem.Image"
          class="gallery-modal_image"
          [src]="worksheetItem.Image | contentImage: '0' : 'marketplace'"
          [alt]="worksheetItem.Title"
          [@zoomAnimation]
        />
      </div>
    </div>
  </ng-template>
</ng-container>

<section
  *ngIf="worksheetItem.WorksheetType === worksheetType.ProviderVideo"
  class="worksheet-card worksheet-card-video"
  [attr.aria-label]="worksheetItem.Title"
>
  <ng-container [ngSwitch]="worksheetItem.ProviderId">
    <fgb-facebook-player *ngSwitchCase="providerName.Facebook" [streamKey]="worksheetItem.ProviderKey" />
    <fgb-youtube-player *ngSwitchCase="providerName.YouTube" [streamKey]="worksheetItem.ProviderKey" />
    <fgb-svp-player *ngSwitchCase="providerName.StreamingVideoProvider" [streamKey]="worksheetItem.ProviderKey" />
    <fgb-twitch-player *ngSwitchCase="providerName.Twitch" [streamKey]="worksheetItem.ProviderKey" />
    <fgb-vimeo-player *ngSwitchCase="providerName.Viemo" [streamKey]="worksheetItem.ProviderKey" />
    <fgb-boxcast-player *ngSwitchCase="providerName.Boxcast" [streamKey]="worksheetItem.ProviderKey" />
    <fgb-streamable-player *ngSwitchCase="providerName.Streamable" [streamKey]="worksheetItem.ProviderKey" />
  </ng-container>
</section>

<article
  *ngIf="worksheetItem.WorksheetType === worksheetType.Link"
  class="worksheet-card mt-3"
  [attr.aria-label]="worksheetItem.Title"
>
  <ng-container *ngTemplateOutlet="cardImage" />
  <ng-container *ngTemplateOutlet="cardFooter; context: { action: linkAction }" />
</article>
